/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { Storage } from 'aws-amplify';

import { Formik } from "formik";
import * as Yup from "yup";
import uuid from "react-uuid";
import moment from "moment";
import ReCAPTCHA from "react-google-recaptcha";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Checkbox,
  Segment,
  Label,
  TextArea,
} from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { listComplaints, listComplaintUsers } from "../../graphql/queries";
import { createComplaint, createComplaintUser } from "../../graphql/mutations";

import FORM_TEXT from "../common/errors/FormYupFormik";
import MyTextInput from "../common/form/MyTextInput";

import { complaintAddInStart } from "../../redux/complaint/complaint.actions";

const ComplaintFormDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const { comtelData } = useSelector((state) => state.complaintReducer);
  const [isVerifiedCaptcha, setIsVerifiedCaptcha] = useState(false);

  moment().locale("fr");

  const onResolved = (value) => {
    if (value) {
      // console.log('Captcha value:', value);
      setIsVerifiedCaptcha(true);
    }
  };
  // const [paramData, setParamData] = useState();
  // useEffect(() => {
  //   if (params && params.getComplaintEmail) {
  //     setParamData(params.getComplaintEmail);
  //   }
  // }, [params]);

  const [errorMessage, setErrorMessage] = useState(null);
  const [addComplaint] = useMutation(createComplaint, {
    refetchQueries: [{ query: listComplaints }],
    onError: (error) => {
      console.error(error.message);
      setErrorMessage("Une erreur technique s'est produite");
    },
  });

  const [addUserComplaint] = useMutation(createComplaintUser, {
    refetchQueries: [{ query: listComplaintUsers }],
    onError: (error) => {
      console.error(error.message);
      setErrorMessage("Une erreur technique s'est produite");
    },
  });

  const initialValues = {
    firstname: comtelData.firstname,
    lastname: comtelData.lastname,
    phone: comtelData.phone,
    email: comtelData.email,
    company: comtelData.company,
    complaintType: "Membre du personnel",
    object: "",
    description: "",
    createdAt: "",
    confirmation: "",
    // policy: false,
  };

  const validationSchema = Yup.object().shape({
    // policy: Yup.boolean().oneOf([true], "This field must be checked"),
    object: Yup.string().required(FORM_TEXT.REQUIRED_FR),
    // firstname: Yup.string().required(FORM_TEXT.REQUIRED_FR),
    // lastname: Yup.string().required(FORM_TEXT.REQUIRED_FR),
    // phone: Yup.string().required(FORM_TEXT.REQUIRED_FR),
    // email: Yup.string()
    //   .email(FORM_TEXT.REQUIRED_VALID_EMAIL_FR)
    //   .max(255)
    //   .required(FORM_TEXT.REQUIRED_FR),
    // company: Yup.string().required(FORM_TEXT.REQUIRED_FR),
  });

  // description
  const MAX_LENGHT = 500;
  const [descriptionData, setDescriptionData] = useState("");
  const [descriptionError, setDescriptionError] = useState("");

  const [characterCount, setCharacterCount] = useState(0);

  const handleNumberCharChange = (event) => {
    setCharacterCount(event.target.value.length);
    setDescriptionData(event.target.value);
    setDescriptionError("");
  };

  const [policy, setPolicy] = useState("No");
  const [policyError, setPolicyError] = useState("");
  const handleActionCheckbox = (event, { value }) => {
    setPolicy(value);
    setPolicyError("");
  };

  // const [file, setFile] = useState('');
  // const [filenameData, setFilenameData] = useState('');

  // const onChange = (event) => {
  //   const fileObj = event.target.files[0];
  //   setFile(fileObj);
  //   setFilenameData(fileObj.name);
  // };

  // const sendToS3 = async (filename, file) => {
  //   await Storage.put(filename, file, {
  //     acl: 'public-read',
  //     level: 'public',
  //     contentType: file.type
  //   })
  //     .then(() => {
  //       console.log('Successfully saved file in S3');
  //       setFile();
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };


  const handleSubmit = async (values) => {
    if (descriptionData === "") {
      setDescriptionError("La description est obligatoire");
      return;
    }

    if (policy === "No") {
      setPolicyError("Vous devez accepter les termes et conditions");
      return;
    }

    if (values.email === "") {
      values.email = process.env.REACT_APP_COMTEL_ANONYME_EMAIL;
    }

    if (values.firstname === "") {
      values.firstname = "Utilisateur Anonyme";
    }

    if (values.lastname === "") {
      values.lastname = "Utilisateur Anonyme";
    }

    const payload = {
      cognitoId: uuid(),
      object: values.object,
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      phone: values.phone,
      company: values.company,
      complaintType: values.complaintType,
      description: descriptionData,
      createdAt: moment().format("LLLL"),
      confirmation: uuid(),
      statut: "Brute",
      responsable: "",
      filename: "",
      // filename: filenameData,
      modeSoumission: "Site Web",
    };


    // alert(JSON.stringify(payload, null, 2));

    addComplaint({
      variables: { input: payload },
    });

    if (errorMessage === null) {
      dispatch(complaintAddInStart(payload));

      // filename not null we sent S3
      // if (filenameData !== '') {
      //   sendToS3(filenameData, file);
      // }

      navigate("/complaint-confirm", { replace: true });
    }
  };

  return (
    <>
      <Message>
        <Header as="h2" color="blue">
          Déposer votre plainte
        </Header>
      </Message>
      <Grid>
        <Grid.Column>
          <>
            {errorMessage && (
              <Message
                negative
                attached
                header="Il y avait quelques erreurs avec votre soumission!"
                content={errorMessage}
              />
            )}

            <Segment attached>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ handleSubmit, values }) => (
                  <Form size="large" onSubmit={handleSubmit}>
                    <Segment color="blue">
                      <Label as="a" color="blue" ribbon>
                        Les renseignements personnels
                      </Label>

                      <Form.Group widths="equal">
                        <Form.Field>
                          <MyTextInput
                            name="firstname"
                            placeholder="Votre prénom"
                          />
                        </Form.Field>
                        <Form.Field>
                          <MyTextInput
                            name="lastname"
                            placeholder="Votre nom"
                          />
                        </Form.Field>
                        <Form.Field>
                          <MyTextInput
                            name="phone"
                            placeholder="Votre numéro de téléphone"
                          />
                        </Form.Field>
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Field>
                          <MyTextInput name="email" placeholder="Votre email" />
                        </Form.Field>
                        <Form.Field>
                          <MyTextInput
                            name="company"
                            placeholder="Votre Société"
                          />
                        </Form.Field>
                      </Form.Group>
                    </Segment>
                    <Segment color="blue">
                      <Label as="a" color="blue" ribbon>
                        Plainte
                      </Label>

                      <Form.Group widths="equal">
                        <Form.Field>
                          <MyTextInput
                            name="object"
                            placeholder="Objet de la plainte"
                          />
                        </Form.Field>
                        <Form.Field>
                          <MyTextInput disabled name="complaintType" />
                        </Form.Field>
                      </Form.Group>
                      <Form.Field>
                        <TextArea
                          maxLength={MAX_LENGHT}
                          name="description"
                          placeholder="Description"
                          rows={5}
                          value={descriptionData}
                          onChange={handleNumberCharChange}
                        />
                        Il vous reste:
                        <Label circular color="green">
                          {MAX_LENGHT - characterCount}
                        </Label>
                        {descriptionError && (
                          <Label basic color="red" pointing>
                            {descriptionError}
                          </Label>
                        )}
                      </Form.Field>
                      <Message>
                        <Message.Header>Termes et conditions</Message.Header>
                        <p>
                        Je certifie que les informations contenues dans la présente plainte sont exactes.
                        </p>
                      </Message>
                      {/* <Form.Field>
                        <input type="file" accept=".pdf,.doc" onChange={(evt) => onChange(evt)} />
                      </Form.Field> */}
                      <Form.Field
                        control={Checkbox}
                        label="J'accepte les termes et conditions"
                        value="Yes"
                        checked={policy === "Yes"}
                        name="policy"
                        onChange={handleActionCheckbox}
                      />
                      <Form.Field>
                        {policyError && (
                          <Label basic color="red" pointing>
                            {policyError}
                          </Label>
                        )}
                      </Form.Field>
                    </Segment>
                    <Segment>
                      <ReCAPTCHA
                        sitekey={
                          process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
                        }
                        onChange={onResolved}
                      />
                    </Segment>
                    <Button.Group>
                      <Button
                        as={Link}
                        fluid
                        to="/"
                        type="submit"
                        floated="right"
                        content="Annuler"
                      />
                      <Button.Or text="OU" />
                      <Button
                        disabled={!isVerifiedCaptcha}
                        fluid
                        type="submit"
                        floated="right"
                        positive
                        content="Déposer votre plainte"
                      />
                    </Button.Group>
                  </Form>
                )}
              </Formik>
            </Segment>
          </>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default ComplaintFormDetail;
